import CollectionCard from "./collection-card";

export default CollectionCard;